export const DOCS_LINK = "https://docs.composo.ai";
export const AUTH_PATH = "/auth";

